export default __webpack_public_path__ + "static/media/SR_2.f88f35e4.png";